import { api } from '../config/api'

const faqsEndpoint = '/FrequentlyAskedQuestion'

export const getFaqSections = () => api.get(`${faqsEndpoint}/Sections`)

export const getFaqQuestions = sectionId => api.get(`${faqsEndpoint}/GetAll`, { params: { category: sectionId } })
